import { EmailAvailabilityPayload } from 'models/endpoints-payload'
import { EmailAvailabilityResponse } from 'models/endpoints-respone'
import { DomainType } from 'models/cookies'

import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string
declare const BIZ_BASE_URL_WT: string

export const checkEmailAvailability = (
  payload: EmailAvailabilityPayload,
  domainType: DomainType = 'user',
): Promise<EmailAvailabilityResponse> => {
  const email = payload.email.trim().toLowerCase()
  return promiseWrapper<EmailAvailabilityResponse, EmailAvailabilityPayload>(
    `${domainType === 'user' ? USER_BASE_URL_WT : BIZ_BASE_URL_WT}/api/public/emailAvailable/${email}`,
    'GET',
  )
}
